import { createTheme, Button, TextInput, Textarea, Chip, Checkbox } from '@mantine/core';

// Paleta real, sacada de los logos del proyecto:
//   forvet_logo.svg      -> #77BEE1 (celeste) + #FFF
//   logo-forvet-dark.svg -> #77BEE1 + #0A033C (navy)
//   grand/ipg-logo.png   -> #0086B9 / #005E9E / #61AFD6
export const BRAND = {
  forvetNavy: '#0A033C',
  forvetCeleste: '#77BEE1',
  ipgAzul: '#0086B9',
  ipgCeleste: '#61AFD6',
};

// Colores DE TRABAJO. El navy #0A033C y el celeste #77BEE1 de los logos son
// muy saturados para cubrir superficies grandes: se usan como referencia de
// marca, y para pintar se usan estas versiones apagadas. Todos los pares
// verificados por contraste (ver abajo).
export const UI = {
  fondo: '#FBFDFE',
  tinta: '#173F6E',       // titulos y texto principal   10,4:1 sobre el fondo
  tintaSuave: '#4A7098',  // texto secundario             5,1:1
  accion: '#1F4C7A',      // botones y opcion marcada     8,9:1 con blanco
  borde: '#DCEAF5',       // bordes de campos y opciones
  bordeActivo: '#96C9E7',
};

// Los gajos alternan por VALOR y no por tono, porque las dos marcas son
// azules: 5,5:1 entre gajos vecinos, suficiente para leer la alternancia
// desde la punta del pasillo (§5) sin el bloque de navy puro.
export const SLICE = {
  FORVET: { fill: '#23527F', text: '#FFFFFF' },
  IPG: { fill: '#B4D9EE', text: UI.tinta },
};

export const kioskTheme = createTheme({
  fontFamily: 'Montserrat, system-ui, -apple-system, sans-serif',
  headings: { fontFamily: 'Montserrat, system-ui, sans-serif', fontWeight: '800' },
  primaryColor: 'forvet',
  primaryShade: 7,
  defaultRadius: 'md',
  focusRing: 'always',

  colors: {
    // De celeste a navy. La version anterior aclaraba el indigo #0A033C y
    // los tonos claros salian lavanda (#a9a1cd, #5c4c9c): fuera de marca y
    // era lo que teñia bordes y textos del formulario.
    forvet: [
      '#FBFDFE', '#EDF6FB', '#DCEAF5', '#BFD9EC', '#96BDDA',
      '#6D9CC2', '#4A7098', '#173F6E', '#12325A', '#0A033C',
    ],
    celeste: [
      '#eaf6fc', '#d6ebf6', '#b3daee', '#94cbe7', '#77BEE1',
      '#69b6dd', '#5cb0da', '#4faad7', '#3d97c4', '#2b7fa8',
    ],
    ipg: [
      '#e8f4fa', '#cfe8f4', '#a5d3e9', '#7cbfdf', '#61AFD6',
      '#4a9fcb', '#3690bd', '#0086B9', '#0071a0', '#005E9E',
    ],
  },

  components: {
    Button: Button.extend({
      defaultProps: { size: 'xl', radius: 'md' },
      styles: { root: { minHeight: 64, fontSize: 22, fontWeight: 700, letterSpacing: '.02em' } },
    }),
    TextInput: TextInput.extend({
      defaultProps: { size: 'xl' },
      styles: {
        input: { minHeight: 64, fontSize: 24, borderWidth: 2 },
        label: { fontSize: 20, fontWeight: 600, marginBottom: 8 },
      },
    }),
    Textarea: Textarea.extend({
      defaultProps: { size: 'xl' },
      styles: {
        input: { fontSize: 22, borderWidth: 2 },
        label: { fontSize: 20, fontWeight: 600, marginBottom: 8 },
      },
    }),
    Chip: Chip.extend({
      defaultProps: { size: 'xl', radius: 'md', variant: 'outline' },
      styles: { label: { minHeight: 64, fontSize: 20, paddingInline: 24, borderWidth: 2 } },
    }),
    Checkbox: Checkbox.extend({
      defaultProps: { size: 'lg' },
      styles: { label: { fontSize: 19, lineHeight: 1.35, paddingInlineStart: 14 } },
    }),
  },

  other: { BRAND, SLICE, UI },
});
